export default function useVehicleMakeModelYear(vehicle) {
  const hasMakeModelYear = !!vehicle?.vehicleMake && !!vehicle?.vehicleModel && !!vehicle?.vehicleYear;
  const makeModelYear = `${vehicle?.vehicleYear} ${vehicle?.vehicleMake} ${vehicle?.vehicleModel}`;

  return {
    hasMakeModelYear,
    makeModelYear
  };
}
